/**
 * Page-view tracker — fires on every route change.
 * Generates a per-tab session id so admin can see "online now" count.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "@/lib/api";

function _sessionId() {
  let id = sessionStorage.getItem("raanah_sid");
  if (!id) {
    id = `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem("raanah_sid", id);
  }
  return id;
}

export default function usePageTracking() {
  const location = useLocation();
  const lastPathRef = useRef("");

  useEffect(() => {
    if (lastPathRef.current === location.pathname) return;
    lastPathRef.current = location.pathname;
    const params = new URLSearchParams(location.search || "");
    // Fire-and-forget; analytics failures must never block the UI
    apiClient.post("/track", {
      path: location.pathname,
      referrer: document.referrer || null,
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      session_id: _sessionId(),
    }).catch(() => {});
  }, [location.pathname, location.search]);
}
